// Layer 3 (Transformation): the What is off chart captions (polish.P11 r1).
import type { OffChart } from './Circuits.transform';

/** The case a chart's caption carries as a chip, or null. The hardness case is
 *  the page's own scenario — the Grinding bottleneck read and the phase header
 *  already name it — so its charts carry no case chip (the comp's JT-023 has
 *  none); any other open case (EX-SA03 on Ag, ZN-REC on pH) keeps its chip. */
export function captionCase(item: Pick<OffChart, 'caseId' | 'caseKind'>): string | null {
  if (!item.caseId || item.caseKind === 'hardness') return null;
  return item.caseId;
}
